//import Libraries
import React from 'react';

//import Components
import Language from '../../../../language/language.json';
import SubDepartmentCard from './SubDepartmentCard/SubDepartmentCard';

//import Style classes
import './DepartmentCard.css';


const departmentCard = (props) => {

    let subDepartments = props.data.subDepartments.map((obj, idx)=>{
        if(props.data.link === "engineering" & idx === 1){
            return null;
        }else{
            return <SubDepartmentCard 
            subDepartmentCount={props.data.link === "engineering" ? 1 : props.data.subDepartments.length} 
            data={obj} key={idx} index={idx} 
            lang={props.lang} 
            link={props.data.link+"/"+idx}/>
        }
    })
    return (
            <div className='DepartmentCard'>
                <div className='MainDept' onClick={()=>{window.location.href = "/"+props.data.link}}>
                    <h3 className='DeptName'>{props.data.name[props.lang]}</h3>
                    <img src={require("../../../../assets/company/image-"+props.index+".jpg")} alt=""/>
                </div>
                <div className='SubDeptWrapper'>
                    {subDepartments}
                </div>
            </div>
    );
}

export default departmentCard;


// WEBPACK FOOTER //
// ./src/pages/Home/Company/DepartmentCard/DepartmentCard.js